import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import "./shopitemview.css";
import { Row, Col, Container } from "react-bootstrap";
import BackArrow from "../backArrow";
import RedoIcon from "@mui/icons-material/Redo";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SuccessNotify } from "../../constants/tostify";
import { FailedNotify } from "../../constants/tostify";
import ShareModel from "../Sharemodel";
import ShareOption from "../Shareoption";
import Loader from "../Loader";
import { useSelector } from "react-redux";
import { getAsset, formatCurrencyCode } from "../../helpers/helper";
import MainModal from "../ui/modal/modal";
import Skeleton from "@mui/material/Skeleton";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import { useShopItemDetail } from "../../hooks/useShopItemDetail";
import { useGetMyManagedShopsQuery } from "../../features/shop/shopMemberApiSlice";
import { useGetShopByIdQuery } from "../../features/shop/shopApiSlice";
import { decodeId } from "../../utils/idObfuscator";

const ShopItemsView = ({ index, update, deleteurl, urlone }) => {
  const { name } = useSelector((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, shopid } = useParams();
  const handleClose = () => setShows(false);
  const [shows, setShows] = useState(false);

  const cleanShopId = decodeId(shopid) || shopid || "";
  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, {
    skip: !cleanShopId,
  });
  const shopOwnerId =
    shopRes?.data?.Shop?.userid?._id || shopRes?.data?.Shop?.userid;
  const isOwner = Boolean(
    name?._id && shopOwnerId && String(name._id) === String(shopOwnerId)
  );

  const { data: managedShopsRes } = useGetMyManagedShopsQuery(undefined, {
    skip: !name?._id || isOwner,
  });

  const currentMembership = (managedShopsRes?.data?.managedShops || []).find(
    (m) => {
      const sId = m?.shopId?._id || m?.shopId;
      return (
        sId &&
        (String(sId) === String(cleanShopId) ||
          String(sId) === String(shopid))
      );
    },
  );

  const isManagedMember = Boolean(currentMembership);
  const memberAccessAreas = currentMembership?.accessAreas || [];

  const canManageItems =
    isOwner ||
    (isManagedMember && memberAccessAreas.includes("post-edit-items"));

  const {
    itemDetail: Itemdata,
    isLoading,
    isError,
    error,
    deleteShopItem,
    isDeleting,
  } = useShopItemDetail(id);

  useEffect(() => {
    if (Itemdata) {
      const thumimgs = document?.querySelectorAll(
        ".image-gallery-thumbnail-image"
      );

      thumimgs?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  useEffect(() => {
    if (Itemdata) {
      const img = document?.querySelectorAll(".image-gallery-image");

      img?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [Itemdata]);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.removeAttribute("crossorigin");
    e.target.src = noImagePlaceholder;
  };

  const validImages = Itemdata?.images?.filter((img) => img && img !== "null" && img !== "undefined") || [];
  const hasImage = validImages.length > 0;

  const ShopModelCarousal = validImages.map((image, index) => ({
    id: index + 1,
    original: getAsset(image),
    thumbnail: getAsset(image),
    renderItem: (item) => (
      <img
        src={item.original}
        alt="item"
        onError={handleImageError}
        crossOrigin="anonymous"
        className="image-gallery-image"
      />
    ),
  }));

  const Deleteitem = () => {
    deleteShopItem(id)
      .unwrap()
      .then((response) => {
        if (response.success) {
          SuccessNotify("Item Deleted Successfully");
          setShows(false);
          if (
            location.pathname === `/singleitem-show/${id}`
          ) {
            navigate(`${urlone}`);
          } else {
            setShows(false);
            navigate(`${deleteurl}/${shopid}`);
          }
        }
      })
      .catch((e) => {
        FailedNotify("Failed to Delete Try Again!");
      });
  };

  const [showmodal, setShowmodal] = useState(false);
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);

  const [showshare, setShowshare] = useState(false);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  if (isLoading) {
    return (
      <Container>
        <div className="screenHeight">
          <div className="ps-5 mb-4">
            <Skeleton variant="text" width="20%" height={30} />
          </div>
          <Row>
            <Col lg="6">
              <Skeleton variant="rectangular" width="100%" height={400} />
            </Col>
            <Col lg="6">
              <div className="ps-4 pe-4 pt-4 pb-1 bg-vilot View-Model-Shadow" style={{ height: "100%" }}>
                <Skeleton variant="text" width="60%" height={40} className="mb-3" />
                <Skeleton variant="text" width="100%" height={80} className="mb-3" />
                <Skeleton variant="text" width="40%" height={40} className="mb-3" />
                <Skeleton variant="text" width="50%" height={30} className="mb-3" />
                <Skeleton variant="rectangular" width="30%" height={40} className="mb-4" />
                <div className="d-flex">
                  <Skeleton variant="rectangular" width="100px" height={40} className="me-3" />
                  <Skeleton variant="rectangular" width="100px" height={40} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }

  if (isError) {
    return (
      <Container>
        <div className="text-center mt-5">
          <h3 style={{ color: "red" }}>Error loading item details.</h3>
          <p>{error?.data?.message || "Something went wrong. Please try again later."}</p>
        </div>
      </Container>
    );
  }

  if (isDeleting) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shareurl={window.location.href}
        shopid={shopid}
        shopTitle={Itemdata?.itemname}
        shopDesc={Itemdata?.description}
        shopImage={hasImage ? validImages[0] : ""}
      />
      {shows && (
        <MainModal
          variant="deleteModal"
          show={!!shows}
          shows={!!shows}
          title="Profile"
          handleClose={handleClose}
          animation={true}
          handleDelete={Deleteitem}
          handledelete={Deleteitem}
        />
      )}
      <Container>
        <div className="screenHeight shop-item-view-page">
          <div className="shop-item-back">
            {location.pathname === `/singleitem-show/${id}` ? (
              <BackArrow back={`${urlone}`} />
            ) : (
              <BackArrow back={`${urlone}/${shopid}`} />
            )}
          </div>
          <div className="ps-5 shop-item-created-at">
            <h5>{Itemdata?.createdAt}</h5>
          </div>
          <Row>
            <Col lg="6">
              <div className="row ">
                {ShopModelCarousal.length > 0 ? (
                  <ImageGallery
                    showPlayButton={false}
                    showFullscreenButton={false}
                    items={ShopModelCarousal}
                  />
                ) : (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center w-100"
                    style={{ minHeight: "280px", background: "#f8f9fa", borderRadius: "8px" }}
                  >
                    <img
                      src={hasImage ? getAsset(Itemdata.images[0]) : noImagePlaceholder}
                      alt="No Image Found"
                      style={{ width: "70%", maxHeight: "200px", objectFit: "contain", opacity: 0.7 }}
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImagePlaceholder;
                      }}
                    />
                    <p className="text-muted mt-2 mb-0" style={{ fontSize: "13px", fontWeight: 500 }}>
                      No Image Found
                    </p>
                  </div>
                )}
              </div>

            </Col>
            <Col lg="6" className="shop-item-details-column">
              <div className="shop-item-details-panel bg-vilot View-Model-Shadow">
                <div className="shop-item-details-content">
                  <div className="shop-item-header">
                    <h4 className="fw-bold">{Itemdata?.itemname}</h4>
                    <button className="shareItembtn" onClick={handleShow}>
                      Share <RedoIcon className="share_icon_f" />
                    </button>
                  </div>
                  <p className="fw-lighter create-desc noscroll shop-item-description">{Itemdata?.description}</p>
                  <h3 className="font-blue shop-item-price">
                    {formatCurrencyCode(Itemdata?.currency)}
                    &nbsp;
                    {Itemdata?.price}
                  </h3>
                  <div className="shop-item-contact">
                    <p className="mb-0">Contact us on</p>
                    <p className="mb-0 pt-2 pb-2">{name.email}</p>
                    <p className="mb-0">{name.phonenumber}</p>
                  </div>
                  <div className="bg-white quantityBox shop-item-quantity d-flex align-items-center">
                    <p className="mb-0">Quantity: {Itemdata?.quantity}</p>
                  </div>
                  <div className="shop-item-actions d-flex">
                    <button
                      className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
                      onClick={() => setShows(true)}
                    >
                      <DeleteOutlineOutlinedIcon />
                      <span className="ps-1">Delete</span>
                    </button>
                    <button
                      className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white"
                      onClick={() => navigate(`${update}/${id}`)}
                    >
                      <CreateOutlinedIcon />
                      <span className="ps-1">Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default ShopItemsView;
